export default "__VITE_ASSET__csnpMvuE__"